import { lifeCarePlanConfig } from './LifeCarePlan/lifeCarePlanConfig';
import { economicDamagesConfig } from './EconomicDamages/economicDamagesConfig';

export const reportConfigs = {
  'life-care-plan': lifeCarePlanConfig,
  'economic-damages': economicDamagesConfig,
};